import { createApiClient } from "#/shared/api/client";

/**
 * Posts the Page Builder edit form as an in-place save.
 *
 * @returns {{ save: (url: String, body: FormData) => Promise<*> }} `save` resolves with the response payload: the
 *   saved state as an object, or the page as a string when the server answers HTML. It rejects with an `HttpError`
 *   on an error status, a timeout or a network failure.
 */
export function createInPlaceSaveApi() {
  // An XHR save leaves no flash for the next page load.
  const client = createApiClient({ parse: false, headers: { "X-Requested-With": "XMLHttpRequest" } });

  return {
    save(url, body) {
      body.set("in_place_save", "true");

      return client.post(url, body);
    },
  };
}
